export { default as Button } from './Button'
export { default as ButtonImage } from './ButtonImage'
export { default as ButtonPix } from './ButtonPix'
export { default as ButtonInvoice } from './ButtonInvoice'



// WEBPACK FOOTER //
// ./src/shared/components/Button/index.js